import type { RefObject } from 'react';

import type { MarketAppWithTabs, WidgetV2 } from '@/features/Dashboard/types';
import type { BaseTabType } from '@/types/markets';

// ============================================================================
// Drag-Drop Types
// ============================================================================

export interface DragOperation {
  source: {
    id?: string;
    type?: string;
    data?: Record<string, unknown>;
  } | null;
  target?: {
    id?: string;
    type?: string;
    group?: string;
    data?: Record<string, unknown>;
  };
}

export interface DragEvent {
  operation?: DragOperation;
}

// ============================================================================
// Component Props Types
// ============================================================================

export interface ItemProps {
  index: number;
  item: WidgetV2;
  column: string;
  onRemoveItem: (id: string) => void;
  onEdit: (tabId: string) => void;
  container: RefObject<HTMLDivElement | null>;
  isSingleItem: boolean;
  currentDashboardName: string;
  currentTabId: string;
  onTabCreated?: (tabName: string, tabId: string) => void;
  onRename: (name: string) => void;
}

export interface ColumnProps {
  id: string;
  index: number;
  items: WidgetV2[];
  onRemoveApp: (id: string) => void;
  onRemoveItem: (id: string) => void;
  container: RefObject<HTMLDivElement | null>;
  currentDashboardName: string;
  currentTabId: string;
  app: MarketAppWithTabs;
  onTabCreated?: (tabName: string, tabId: string) => void;
  preview?: AppsOrderPreview | null;
}

export interface AppsOrderProps {
  onTabCreated?: (tabName: string, tabId: string) => void;
  preview?: AppsOrderPreview | null;
}

// ============================================================================
// Preview Types
// ============================================================================

export interface AppsOrderPreview {
  components?: Array<{
    tabs?: BaseTabType[];
  }>;
}

// ============================================================================
// Move Menu Types
// ============================================================================

export type MoveMenuVariant = 'app' | 'item';

export interface MoveMenuBaseProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onRemoveFromCurrent: () => void;
}

export interface MoveAppMenuProps extends MoveMenuBaseProps {
  variant: 'app';
  app: MarketAppWithTabs;
}

export interface MoveItemMenuProps extends MoveMenuBaseProps {
  variant: 'item';
  item: WidgetV2;
  appId: string;
  currentDashboardName: string;
  currentTabId: string;
  onTabCreated?: (tabName: string, tabId: string) => void;
}

export type MoveMenuProps = MoveAppMenuProps | MoveItemMenuProps;

// ============================================================================
// Constants
// ============================================================================

export const BLANK_COLUMN_ID = '__blank__';
